import {TicketState} from "./ticket-state";

export const TicketStateLabel: Record<string, string> = {
  [TicketState.NEW]: 'Nieuw',
  [TicketState.PENDING]: 'In behandeling',
  [TicketState.DONE]: 'Afgehandeld',
  [TicketState.CLOSED]: 'Gesloten',
};
